import { render } from "./CrdmDay.vue?vue&type=template&id=4a526823&scoped=true"
import script from "./CrdmDay.vue?vue&type=script&lang=js"
export * from "./CrdmDay.vue?vue&type=script&lang=js"

import "./CrdmDay.vue?vue&type=style&index=0&id=4a526823&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4a526823"

export default script